var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-layout',_vm._b({staticClass:"page-devices"},'app-page-layout',_vm.content,false),[_vm._l((_vm.content.data),function(device,index){return [(device.adv)?_c('app-device-advertisement',{key:index,attrs:{"device":device.adv}}):_vm._e(),_c('app-device-block',{key:index,attrs:{"device":device}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }